export const GET_WALLET_TYPE_LIST = "GET_WALLET_TYPE_LIST";
export const CREATE_WALLET_TYPE = "CREATE_WALLET_TYPE";
export const SHOW_WALLET_TYPE = "SHOW_WALLET_TYPE";
export const UPDATE_WALLET_TYPE = "UPDATE_WALLET_TYPE";
export const DELETE_WALLET_TYPE = "DELETE_WALLET_TYPE";
export const UPDATE_STATUS_WALLET_TYPE = "UPDATE_STATUS_WALLET_TYPE";
